module.exports = __webpack_public_path__ + "img/Intro_text03_behavior.db81305c.png";